import { HttpClient, HttpStatusCode } from 'data/protocols/http';
import { InvalidCredentialsError, UnexpectedError } from 'domain/errors';
import { RemovePersonFromGroupUseCaseInterface } from 'domain/usecases';

export class RemoteRemovePersonFromGroup
  implements RemovePersonFromGroupUseCaseInterface
{
  constructor(
    private readonly url: string,
    private readonly httpClient: HttpClient<RemovePersonFromGroupUseCaseInterface.Result>,
  ) {}

  async execute(
    params: RemovePersonFromGroupUseCaseInterface.Params,
  ): Promise<RemovePersonFromGroupUseCaseInterface.Result> {
    const httpResponse = await this.httpClient.request({
      url: `${this.url}/${params.relationId}`,
      method: 'delete',
    });

    switch (httpResponse.statusCode) {
      case HttpStatusCode.ok:
        return httpResponse.body;
      case HttpStatusCode.forbidden:
        throw new InvalidCredentialsError();
      default:
        throw new UnexpectedError();
    }
  }
}
